//#region IMPORTS
import { InstoreOrderLineTableRow } from "../../models/instoreOrder";
import { useVirtualizer } from "@tanstack/react-virtual";
import { Row, Table } from "@tanstack/react-table";
import { RefObject } from "react";
import InstoreOrderDetailTableBodyRow from "./InstoreOrderDetailTableBodyRow";
//#endregion

interface Props {
  tableContainerRef: RefObject<HTMLDivElement>;
  table: Table<InstoreOrderLineTableRow>;
}

export default function InstoreOrderDetailTableBody({
  tableContainerRef,
  table,
}: Props) {
  const { rows } = table.getRowModel();

  // Important: Keep the row virtualizer in the lowest component possible to avoid unnecessary re-renders.
  const rowVirtualizer = useVirtualizer<HTMLDivElement, HTMLTableRowElement>({
    count: rows.length,
    estimateSize: () => 33, //estimate row height for accurate scrollbar dragging
    getScrollElement: () => tableContainerRef.current,
    //measure dynamic row height, except in firefox because it measures table border height incorrectly
    measureElement:
      typeof window !== "undefined" &&
      navigator.userAgent.indexOf("Firefox") === -1
        ? (element) => element?.getBoundingClientRect().height
        : undefined,
    overscan: 5,
  });

  return (
    <tbody
      className="bg-white mb-16 pb-6 grid relative"
      style={{
        height: `${rowVirtualizer.getTotalSize()}px`, //tells scrollbar how big the table is
      }}
    >
      {rowVirtualizer.getVirtualItems().map((virtualRow) => {
        const row = rows[virtualRow.index] as Row<InstoreOrderLineTableRow>;
        return (
          <InstoreOrderDetailTableBodyRow
            key={row.id}
            row={row}
            virtualRow={virtualRow}
            rowVirtualizer={rowVirtualizer}
          />
        );
      })}
    </tbody>
  );
}
